import { render, staticRenderFns } from "./HeaderTime.vue?vue&type=template&id=01c238dc&scoped=true"
import script from "./HeaderTime.vue?vue&type=script&lang=js"
export * from "./HeaderTime.vue?vue&type=script&lang=js"
import style0 from "./HeaderTime.vue?vue&type=style&index=0&id=01c238dc&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01c238dc",
  null
  
)

export default component.exports